// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.earthwallet",
    name: "Earth Wallet",
    homepage: "https://www.earthwallet.io/",
    image_id: "d3f724c4-f99b-476f-10f8-12aa4af13800",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/earth-wallet/id1638414929",
        android: "https://play.google.com/store/apps/details?id=earth.wallet.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/earth-wallet/agkfnefiabmfpanochlcakggnkdfmmjd",
        firefox: "https://chrome.google.com/webstore/detail/earth-wallet/agkfnefiabmfpanochlcakggnkdfmmjd",
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "earthwallet://",
        universal: "https://wallet.earth",
    },
    desktop: {
        native: "earthwallet://",
        universal: "https://wallet.earth",
    },
};
//# sourceMappingURL=index.js.map